import React from 'react';
import { createContainer } from 'unstated-next';

function useSelectedRecipes() {
    const [selectedRecipes, setSelectedRecipes] = React.useState<Record<number, boolean>>({});
    const toggleRecipe = (idx: number) =>
        setSelectedRecipes((selectedRecipes) => ({
            ...selectedRecipes,
            [idx]: !selectedRecipes[idx],
        }));

    return { selectedRecipes, toggleRecipe };
}

export const SelectedRecipes = createContainer(useSelectedRecipes);
